import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import EmbedCallForImpactCarousel from '../components';


function mapStateToProps() {
  return {
  };
}

function mapDispatchToProps() {
  return {
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EmbedCallForImpactCarousel));



// WEBPACK FOOTER //
// ./src/routes/Embed/CallForImpact/Carousel/container/index.js